export default "__VITE_ASSET__D7J_VL0o__"